import React, { FC, MouseEventHandler } from 'react';
import { Button, ButtonProps } from '../../Button';
import Dropdown from 'react-bootstrap/Dropdown';
import { FAIcon } from '../../fa-icon';
import {
  Button as CoreButton,
  CardFooter as CoreCardFooter,
  DropdownMenu as CoreDropdownMenu,
  Label as CoreLabel,
  Layout as CoreLayout,
} from '../../../core';
import { MenuButton } from '@chakra-ui/react';
import { tokens } from '@everfi/design-system';

export type CardActionBoxButton = ButtonProps & {
  action?: MouseEventHandler<HTMLButtonElement>;
  items?: CardActionBoxButton[];
  'aria-label'?: string;
};

export type CardActionBoxProps = {
  buttons: CardActionBoxButton[];
  chakra?: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

export const CardActionBox: FC<CardActionBoxProps> = props => {
  const { buttons, chakra = 'on', className, onClick } = props;
  if (buttons.length <= 0) {
    return null;
  }
  const createButton = () => {
    return buttons?.map((config, index) => {
      const { action, items, icon, style, rightIcon, rightIconProps, ...rest } = config;

      if (items?.length) {
        return chakra === 'on' ? (
          <CoreDropdownMenu
            items={items.map(item => {
              return {
                text: item.label,
                onClick: item.action,
              };
            })}
            menuButton={
              <CoreButton as={MenuButton} key={`action-button-${index}`} variant={style}>
                {rightIcon && config.label ? (
                  <CoreLabel
                    label={{
                      type: 'iconRight',
                      options: {
                        text: config.label,
                        icon: {
                          iconName: rightIcon || '',
                        },
                      },
                    }}
                  />
                ) : (
                  config.label
                )}
              </CoreButton>
            }
          ></CoreDropdownMenu>
        ) : (
          <Dropdown data-type="dropdown" key={`action-button-${index}`}>
            <Dropdown.Toggle variant={style} className={`ui-default btn btn-${style}`}>
              {config.label}
              {rightIcon && <FAIcon icon={rightIcon} additionalClasses="right" {...rightIconProps} />}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {config.items?.map((item, idx) => (
                <Dropdown.Item key={idx} onClick={item.action}>
                  {item.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        );
      } else {
        return (
          <Button
            {...rest}
            renderAsLegacy={chakra === 'off'}
            style={style}
            icon={icon}
            rightIcon={rightIcon}
            rightIconProps={rightIconProps}
            key={`action-button-${index}`}
            onClick={action}
          />
        );
      }
    });
  };

  return chakra === 'on' ? (
    <div onClick={onClick}>
      <CoreCardFooter>
        <CoreLayout variant="flex" alignItems="center" columnGap={tokens.SpacingBaseSm}>
          {createButton()}
        </CoreLayout>
      </CoreCardFooter>
    </div>
  ) : (
    <div className={className} onClick={onClick}>
      {createButton()}
    </div>
  );
};

CardActionBox.displayName = 'CardActionBox';
